"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var componentStyle = {
    base: {
        width: 35,
        height: 35,
    },
};
var description = 'You can style it as well.';
var code = "import React from 'react';\nimport { Icon } from 'jsc-react-ui';\n\nconst style = {\n  base: {\n    width: 35,\n    height: 35,\n  },\n};\n\nconst Example = () => <Icon style={style} name=\"plus\" color=\"#e74c3c\" />;";
exports.StylingExampleIcon = function () { return (React.createElement(common_1.Example, { title: "Styling", description: description, code: code },
    React.createElement(components_1.Icon, { style: componentStyle.base, name: "plus", color: "#e74c3c" }))); };
exports.StylingExampleIcon.displayName = 'StylingExampleIcon';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentIconPage/StylingExampleIcon.tsx
// module id = 685
// module chunks = 0